import React from 'react'

export const BrillerIkon = () => (
  <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden={true}>
    <g filter="url(#filter0_d_580_1956)">
      <circle cx="24.6588" cy="20.6588" r="20.6588" fill="#CCF1D6" />
      <path
        d="M36.3444 14.412C34.0242 14.0495 31.6591 14.0614 29.343 14.4468C28.5146 14.5824 27.7393 14.9344 27.101 15.4658C26.4626 15.9967 25.9846 16.6864 25.718 17.4611C24.693 17.251 23.6338 17.256 22.6113 17.4755C22.3539 16.6958 21.883 15.9986 21.2497 15.4594C20.6164 14.9196 19.8437 14.5575 19.0148 14.412C16.6952 14.05 14.3305 14.0614 12.015 14.4468C10.9215 14.6276 9.93079 15.1813 9.21928 16.0086C8.50837 16.8354 8.12329 17.8817 8.13299 18.9599V19.7504C8.13299 23.9775 11.2116 27.169 15.2933 27.169C19.6737 27.169 22.8533 24.1606 22.8533 20.016V19.1251C23.7103 18.9225 24.6036 18.919 25.4621 19.1157V19.7479C25.4621 23.9749 28.5407 27.1664 32.6223 27.1664C37.0027 27.1664 40.1824 24.1581 40.1824 20.0134V18.9125C40.1977 17.8413 39.8193 16.7995 39.1161 15.9747C38.4128 15.1498 37.4297 14.5957 36.3444 14.412ZM21.1377 20.0151C21.1377 23.2444 18.7353 25.4995 15.2936 25.4995C11.7574 25.4995 9.84933 22.5373 9.84933 19.7495V18.9599C9.8478 18.2791 10.0919 17.6191 10.5388 17.0952C10.9862 16.5713 11.6082 16.2167 12.2966 16.0926C13.4115 15.9098 14.5402 15.817 15.6714 15.8145C16.6984 15.8135 17.7244 15.8944 18.7382 16.0558C19.419 16.183 20.0324 16.538 20.4716 17.0595C20.9103 17.5814 21.1473 18.2364 21.1406 18.9103L21.1377 20.0151ZM38.469 20.0151C38.469 23.2444 36.0666 25.4995 32.6249 25.4995C29.0887 25.4995 27.1806 22.5373 27.1806 19.7495V18.9599C27.1791 18.2791 27.4232 17.6191 27.8701 17.0952C28.3175 16.5713 28.9395 16.2167 29.6279 16.0926C30.7428 15.9098 31.8715 15.817 33.0027 15.8145C34.0297 15.8135 35.0557 15.8944 36.0695 16.0558C36.7503 16.1825 37.3636 16.538 37.8029 17.0595C38.2421 17.5814 38.4786 18.2364 38.4719 18.9103L38.469 20.0151Z"
        fill="#404040"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_580_1956"
        x="0"
        y="0"
        width="49.3174"
        height="49.3176"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_580_1956" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_580_1956" result="shape" />
      </filter>
    </defs>
  </svg>
)
